import ActionTypes from '../actions/actionTypes';

const initialState = {
  id: null,
  message: '',
  variant: 'neutral',
  isVisible: false,
  dismissable: false,
  x: 'right',
  y: 'bottom',

  isModalOpen: false,
};

export function toastAlertReducer(state = initialState, { type, payload }) {
  switch (type) {
    case ActionTypes.TOAST_ALERT.RESET:
      return {
        ...state,
        message: '',
        variant: 'neutral',
        isVisible: false,
        dismissable: false,
        x: 'right',
        y: 'bottom',
        id: null,
      };
    case ActionTypes.TOAST_ALERT.ADD:
      return {
        ...state,
        message: payload.message,
        variant: payload.variant,
        isVisible: true,
        dismissable: payload.dismissable,
        x: payload.x,
        y: payload.y,
        id: payload.id,
      };
    case ActionTypes.TOAST_ALERT.RESET_MODAL:
      return {
        ...state,
        isModalOpen: false,
      };
    case ActionTypes.TOAST_ALERT.ADD_MODAL:
      return {
        ...state,
        isModalOpen: true,
      };
    default:
      return state;
  }
}